export default[
    {
        path: '/evaluaciones',
        //name: 'admin',
        component: () => import(/* webpackChunkName: "evaluaciones" */ '@/views/Encuestasrh.vue'),
        meta: {
            requiresAuth: false,
            //roles:['ROLE_ADMIN'],
        },
        children:[
            {
                path:'/',
                name:'listEvaluaciones',
                component: () => import(/* webpackChunkName: "listEvaluaciones" */ '@/views/rhumanos/EncuestasMain.vue'),
                meta: {
                    requiresAuth: false,
                    //roles:['ROLE_ADMIN'],
                },
            },
        ]
    },
    //C:\Users\siste\Documents\Desarrollo\sf\santafe20\src\views\admin\personal\externo\PersonalExtenoSolicitud.vue
    {
        path: '/privilegiosmedicos',
        //name: 'admin',
        component: () => import(/* webpackChunkName: "evaluaciones" */ '@/views/admin/personal/externo/PersonalExtenoSolicitud.vue'),
        meta: {
            requiresAuth: false,
            //roles:['ROLE_ADMIN'],
        },
        children:[
            {
                path:'/',
                name:'externoNuevaSol',
                component: () => import(/* webpackChunkName: "externoNuevaSol" */ '@/views/admin/personal/externo/PersonalExternoNuevaSolicitud.vue'),
                meta: {
                    requiresAuth: false,
                    //roles:['ROLE_ADMIN'],
                },
            },
        ]
    },
]